import { MapPin } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none";

export const PropertySelect = ({ properties, value, onChange, allLabel = "No specific property", testId = "property-select", className = "h-11" }) => (
  <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
    <SelectTrigger data-testid={testId} className={className}><SelectValue /></SelectTrigger>
    <SelectContent className="max-h-72">
      <SelectItem value={NONE}>{allLabel}</SelectItem>
      {properties.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const PropertyTag = ({ properties, id }) => {
  const p = properties.find((x) => x.id === id);
  if (!p) return null;
  return <span data-testid="property-tag" className="inline-flex items-center gap-1 rounded bg-navy/5 px-1.5 py-0.5 text-[11px] text-navy"><MapPin className="h-3 w-3" />{p.name}</span>;
};

export const PropertyFilter = ({ properties, value, onChange }) =>
  properties.length > 1 ? (
    <div className="mb-6 w-full sm:w-72">
      <PropertySelect properties={properties} value={value} onChange={onChange} allLabel="All properties" testId="property-filter-select" className="h-10 bg-white" />
    </div>
  ) : null;
